const stripWrappingQuotes = (value) =>
  value.replace(/^['"]+|['"]+$/g, "").trim();

export const normalizeRawToken = (tokenValue) => {
  if (!tokenValue || typeof tokenValue !== "string") return "";
  return stripWrappingQuotes(tokenValue)
    .replace(/^(Token|Bearer)\s+/i, "")
    .trim();
};

export const getStoredJwtToken = () => {
  try {
    const rawToken = localStorage.getItem("token");
    if (!rawToken) return "";
    const parsed = JSON.parse(rawToken);
    return normalizeRawToken(parsed);
  } catch (error) {
    return normalizeRawToken(localStorage.getItem("token"));
  }
};

export const buildAuthHeaders = (jwtToken) => {
  const normalizedAuthToken = normalizeRawToken(
    process.env.REACT_APP_AUTH_TOKEN_DEV
  );
  const normalizedJwtToken = normalizeRawToken(jwtToken || getStoredJwtToken());
  const headers = {};

  if (normalizedAuthToken) {
    headers.Authorization = `Token ${normalizedAuthToken}`;
  }

  if (normalizedJwtToken) {
    headers["X-JWT-TOKEN"] = normalizedJwtToken;
    headers.jwt = normalizedJwtToken;
  }

  return headers;
};
